import { userAgent } from "next/server";
import React, { createContext, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const StateContext = createContext();

export const ContextProvider = ({ children }) => {

  const BACKEND_URL = process.env.REACT_APP_BASE_URL;
  const HIKAL_URL = process.env.REACT_APP_HIKAL_DYNAMIC_URL;
  const PROPERTY_URL = process.env.REACT_APP_PROPERTY_DYNAMIC_URL;
  const APOELEZZ_URL = process.env.REACT_APP_APOELEZZ_DYNAMIC_URL;
  const ASM_URL = process.env.REACT_APP_ASM_DYNAMIC_URL;

  //   const [currentMode, setCurrentMode] = useState("light");
  // const [activeMenu, setActiveMenu] = useState(true);
  const [allRoutes, setAllRoutes] = useState([]);
  const [langCode, setLangCode] = useState("en");
  const [fontFam, setFontFam] = useState("'Raleway', serif");

  // console.log(
  //   "URLS: ",
  //   BACKEND_URL, //DOMAIN
  //   HIKAL_URL, //1
  //   PROPERTY_URL, //4
  //   APOELEZZ_URL, //6
  //   ASM_URL //8
  // );

  // USER INFO
  const [userInfo, setUserInfo] = useState({
    ip: null,
    userAgent: null,
    countryCode: null,
    countryName: null,
    state: null,
  });

  // LANGUAGE
  const { t, i18n } = useTranslation();

  // AVAILABLE LANGS
  const langs = [
    {
      code: "en",
      name: "English",
      title: "English",
      rtl: false,
      flag: "/assets/images/flags/english-flag.png",
      font: "'Raleway', serif",
      size: "12px",
    },
    {
      code: "ar",
      name: "Arabic",
      title: "عربي",
      rtl: true,
      flag: "/assets/images/flags/arabic-flag.png",
      font: "'Cairo', serif",
      size: "12px",
    },
  ];

  // RETRIEVE LANGUAGE DETAILS
  const getLangDetails = (langCode) => {
    const language = langs.find((lang) => lang.code === langCode);
    if (language) {
      const { title, flag, font, rtl } = language;
      document.body.style.direction = rtl ? "rtl" : "ltr";
      document.body.style.setProperty("font-family", font);
      document.body.style.fontFamily = font;
      setFontFam(font);
      return { title, flag };
    }
    return null;
  };

  // CHECK IF LANGUAGE IS RTL
  const isLangRTL = (langCode) => {
    const language = langs.find((lang) => lang.code === langCode);
    return language ? language.rtl : false;
  };

  // CHANGE LANGUAGE
  const changeLanguage = (newLangCode) => {
    setLangCode(newLangCode);
    i18n.changeLanguage(newLangCode);
    getLangDetails(newLangCode);
  };

  // CHECK URL PATH TO SET LANGUAGE
  useEffect(() => {
    const path = window.location.pathname;
    const langFromUrl = path.split("/")[1];
    if (langFromUrl === "ar") {
      changeLanguage("ar");
    } else {
      const langExists = langs.find((lang) => lang.code === langFromUrl);
      if (langExists) {
        changeLanguage(langFromUrl);
      } else {
        changeLanguage("en");
      }
    }
  }, []);

  // APPLY LANGUAGE DETAILS ON INITIAL LOAD
  useEffect(() => {
    getLangDetails(langCode);
  }, [langCode]);

  // CHECK IF TEXT CONTAINS ARABIC CHARACTER
  const isArabic = (text) => {
    const regex = new RegExp(
      "[\u0600-\u06FF\u0750-\u077F\u08a0-\u08ff\uFB50-\uFDFF\uFE70-\uFEFF]+([\u0600-\u06FF\u0750-\u077F\u08a0-\u08ff\uFB50-\uFDFF\uFE70-\uFEFF\\W\\d]+)*",
      "g"
    );
    if (text) {
      return text.match(regex);
    } else {
      return false;
    }
  };

  // CHECK IF TEXT CONTAINS ENGLISH CHARACTER
  const isEnglish = (text) => {
    const regex = new RegExp("^[\u0000-\u007F]+$", "g");
    if (text) {
      return text.match(regex);
    } else {
      return false;
    }
  };

  // FETCH USER INFO
  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        // USER AGENT
        const userAgent = navigator.userAgent;
        // IP AND LOCATION
        const response = await fetch("https://ipapi.co/json/");
        const data = await response.json();

        setUserInfo({
          ip: data.ip,
          userAgent,
          countryCode: data.country_code,
          countryName: data.country_name,
          state: data.region,
        });
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };
    fetchUserInfo();
    // console.log("USER INFO::: ", userInfo);
  }, []);

  useEffect(() => {
    if (userInfo.ip && userInfo.countryName) {
      console.log("USER INFO::: ", userInfo);
    }
  }, [userInfo]);

  return (
    <StateContext.Provider
      value={{
        BACKEND_URL,
        HIKAL_URL,
        PROPERTY_URL,
        APOELEZZ_URL,
        ASM_URL,
        langs,
        langCode,
        setLangCode,
        allRoutes,
        setAllRoutes,
        isArabic,
        isEnglish,
        isLangRTL,
        getLangDetails,
        fontFam,
        setFontFam,
        t,
        i18n,
        changeLanguage,
        userInfo,
        // currentMode,
        // setCurrentMode,
        // activeMenu,
        // setActiveMenu,
      }}
    >
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);
